import { Injectable } from '@angular/core';
import * as math from 'mathjs';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { map,startWith } from 'rxjs/operators';
import { CustomScope } from '../helper/math-js-helper';

@Injectable()
export class MathJsCustomScopeService {
    private scopeUpdated = new Subject<void>();
    private scope: CustomScope;
    public parser = math.parser();

    constructor(private toastr: ToastrService) {
        this.setScope(new CustomScope());
    }

    public setScope(scope: CustomScope) {
        this.scope = scope;
        this.scope.errorHandler = (title, desc) => this.toastr.error(desc, title);
        this.scopeUpdated.next();
    }
    public getScope() {
        return this.scope;
    }
    public readonly scope$ = this.scopeUpdated.pipe(
        startWith(null),
        map(() => this.scope),
    );
}
